import { createSlice } from '@reduxjs/toolkit';
import { deleteDraftDistributionApi } from '../../../rtk-apis/hl7/deleteDraftDistribution';

const initialState = {
  status: '',
  result: null as any,
  msg: '',
  loading: false,
};

const deleteDraftDistributionSlice = createSlice({
  name: 'deleteDraftDistribution',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(deleteDraftDistributionApi.pending, state => {
        state.loading = true;
      })
      .addCase(deleteDraftDistributionApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action.payload;
        state.msg = 'Deleted';
      })
      .addCase(deleteDraftDistributionApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = (action.payload as string) || 'Delete failed';
      });
  },
});

export const { clearState: clearDeleteDraftDistributionState } = deleteDraftDistributionSlice.actions;
export default deleteDraftDistributionSlice.reducer;
